import { useState, useRef } from 'react';
import SearchIcon from '@mui/icons-material/Search';

import Autocomplete from '../../../components/Autocomplete';
import Theme from '../../../layout/Theme';
import { removeVietnameseTones } from '../../../utils/helpers';
import { IconButton } from '../../../components/Button';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { SPECIAL_EXCHANGE } from '../../../constants';

const SearchInput = ({ listCompanies, tickers }) => {
  const searchRef = useRef(null);
  const [open, setOpen] = useState(false);

  const handleChange = (option) => {
    setOpen(false);
    if (
      SPECIAL_EXCHANGE.includes(option.value.toLowerCase()) ||
      tickers.includes(option.value)
    ) {
      document.location.href = `/${option.value}`;
    } else {
      document.location.href = `/${removeVietnameseTones(option.label)}`;
    }
  };

  useOnClickOutside(searchRef, () => setOpen(false));

  return (
    <Theme>
      <div className="relative w-auto md:w-full max-w-xl">
        <div className="md:hidden">
          <IconButton onClick={() => setOpen(!open)}>
            <SearchIcon className="text-gray-700 dark:text-gray-400" />
          </IconButton>
          <div
            className="fixed top-[70px] right-0 left-0 bg-white dark:bg-gray-800 p-2 z-50"
            style={{ display: `${open ? 'block' : 'none'}` }}
            ref={searchRef}
          >
            <Autocomplete
              className="w-full mr-0"
              options={listCompanies}
              placeholder="Nhập mã chứng khoán"
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="hidden md:block mr-2 md:mr-6">
          <Autocomplete
            className="w-full"
            options={listCompanies}
            placeholder="Nhập mã chứng khoán"
            onChange={handleChange}
          />
        </div>
      </div>
    </Theme>
  );
};

export default SearchInput;
